// Entry point: route between sign-in (the SSO), the document list (/) and the editor (/d/<id>).
import { ApiError, me, signIn, watchSignOut } from './api.ts';
import { showHome } from './home.ts';
import { h } from './ui.ts';

const root = document.getElementById('app')!;

async function route(): Promise<void> {
  const user = await me().catch(() => null);
  if (!user) { signIn(); return; }
  watchSignOut();
  const m = /^\/d\/([0-9a-f-]{36})(?:\/edit)?\/?$/i.exec(location.pathname);
  if (!m) { await showHome(root, user); return; }
  try {
    const { openDocument } = await import('./editor/app.ts');
    await openDocument(root, m[1], user);
  } catch (e) {
    const status = e instanceof ApiError ? e.status : 0;
    root.replaceChildren(h('div', { class: 'notice' },
      h('h2', {}, status === 404 ? '문서를 찾을 수 없거나 액세스 권한이 없습니다' : '문서를 열 수 없습니다'),
      h('p', { class: 'muted' }, status === 404 ? '소유자에게 공유를 요청하세요.' : String((e as Error).message)),
      h('a', { href: '/' }, '홈으로')));
  }
}
// for tests and the picker: open a local file as a new document
(window as unknown as { docsOpenFile?: (f: File) => Promise<void> }).docsOpenFile = async f => (await import('./editor/dialogs.ts')).openFileAsNewDoc(f);
void route();
